export default __webpack_public_path__ + "static/media/default-user.b8428432.svg";